import { Component, OnInit, ViewChild } from "@angular/core";
import { DataSharingService } from "../../AuthGuard/DataSharingService";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MasterService } from "../../Shared/app.Masters.Service";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { SnackbarComponent } from "../../snackbar/snackbar.component";

@Component({
    selector: "app-pending-authorization",
    templateUrl: "./pending-authorization.component.html",
    styleUrls: ["./pending-authorization.component.scss"],
    standalone: false
})
export class PendingAuthorizationComponent implements OnInit {
  currentUser: any;
  JsonData: any[] = [];
  dataSource = new MatTableDataSource<any>();
  SelectAll: any;
  IsSelected: boolean = false;

  displayedColumnsModel: string[] = [];
  Search: any = {
    VoucherDateFrom: "",
    VoucherDateTo: "",
    VoucherType: "",
    VoucherSubType: "",
    Status: "Authorization Pending",
  };

  configSuccess: MatSnackBarConfig = {
    panelClass: "style-success",
    duration: 5000,
    horizontalPosition: "right",
    verticalPosition: "top",
  };
  showSpinner = false;
  @ViewChild(MatSort) sort: MatSort;
  @ViewChild(MatPaginator) paginator: MatPaginator;
  constructor(
    private dataSharingService: DataSharingService,
    public snackBar: MatSnackBar,
    private MasterService: MasterService
  ) {}

  ngOnInit(): void {
    this.dataSharingService.HeaderTitle.next("Pending Authorization");
    this.currentUser = JSON.parse(sessionStorage.getItem("currentUser"));
  }
  add30Days(date: Date): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + 30);
    return result;
  }

  // Triggered when either date changes
  onDateChange(type: "from" | "to") {
        this.dataSource = new MatTableDataSource([]);
    const from = this.Search.VoucherDateFrom
      ? new Date(this.Search.VoucherDateFrom)
      : null;
    const to = this.Search.VoucherDateTo
      ? new Date(this.Search.VoucherDateTo)
      : null;

    if (type === "from" && from) {
      const maxToDate = this.add30Days(from);
      if (to && to > maxToDate) {
        this.Search.VoucherDateTo = "";
        this.snackBar.open(
          "Voucher To Date must be within 30 days from Voucher From Date",
          "",
          this.configSuccess
        );
      }
    }

    if (type === "to" && to) {
      const minFromDate = new Date(to);
      minFromDate.setDate(minFromDate.getDate() - 30);
      if (from && from < minFromDate) {
        this.Search.VoucherDateFrom = "";
        this.snackBar.open(
          "Voucher From Date must be within 30 days before Voucher To Date",
          "",
          this.configSuccess
        );
      }
    }
  }

  onSearchPendingAuth() {
    this.showSpinner = true;
    this.displayedColumnsModel = [
      "Select",
      "VoucherId",
      "Voucher_Date",
      "Voucher_Type",
      "Voucher_Sub_Type",
      "Voucher_CreateBy",
      "Voucher_CreateOn",
      "Amount",
    ];

    this.MasterService.Get_Accounting_Authorization_List({
      LoginUserId: this.currentUser.userId,
      FromDate: this.Search.VoucherDateFrom,
      To: this.Search.VoucherDateTo,
      VoucherType: this.Search.VoucherType,
      VoucherStatus: this.Search.Status,
      VoucherSubType: this.Search.VoucherSubType,
    }).subscribe((res: any) => {
      if (res.length > 0) {
        this.JsonData = res;
        this.dataSource = new MatTableDataSource(res);

        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
        console.log("jason", this.JsonData);
      } else {
        this.dataSource = new MatTableDataSource([]);
      }

      this.showSpinner = false;
    });
  }
  hasAuthorizationPending(): boolean {
  return this.dataSource?.data?.some((row: any) => row.Voucher_Status === 'Authorization Pending');
}
hasAnyRowSelected(): boolean {
  return this.dataSource?.data?.some((row: any) => row.IsSelected === true);
}
OnApproved() {
  this.showSpinner = true;

  // Get only selected rows
  const selectedRows = this.dataSource?.data?.filter((row: any) => row.IsSelected);

  // Extract VoucherIds from selected rows
  const voucherIds = selectedRows.map((row: any) => row.VoucherId);

  // Convert to comma-separated string
  const voucherIdString = voucherIds.join(',');

  // Send to API
  const requestPayload = {
    Status: 'Authorized',
    VoucherIds: voucherIdString,
    LoginUserId: this.currentUser.userId
  };

  this.MasterService.Update_Voucher_Authorization_Details(requestPayload).subscribe(
    (res: any) => {
      if (res[0].CODE >= 0) {
        this.showSpinner = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
        this.onSearchPendingAuth()
      } else {
        this.showSpinner = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
      }
      // handle success
    },
    (err: any) => {
      this.showSpinner = false;
      // handle error
    }
  );
}
OnReject() {
  this.showSpinner = true;

  // Get selected rows
  const selectedRows = this.dataSource?.data?.filter((row: any) => row.IsSelected);

  // Extract VoucherIds
  const voucherIds = selectedRows.map((row: any) => row.VoucherId);

  // Convert to comma-separated string
  const voucherIdString = voucherIds.join(',');

  // Prepare request payload
  const requestPayload = {
    Status: 'Rejected',
    VoucherIds: voucherIdString
  };

  this.MasterService.Update_Voucher_Authorization_Details(requestPayload).subscribe(
    (res: any) => {
if (res[0].CODE >= 0) {
        this.showSpinner = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
        this.onSearchPendingAuth()

      } else {
        this.showSpinner = false;
        this.snackBar.openFromComponent(SnackbarComponent, {
          data: res[0].MSG,
          ...this.configSuccess,
        });
      }      // Handle success
    },
    (err: any) => {
      this.showSpinner = false;
      // Handle error
    }
  );
}


  exportPendingAuthTable(exporter: any) {
    exporter.exportTable("xls", {
      fileName: "Pending Authorization Detail",
      sheet: "Pending Authorization Detail",
    });
  }
  checkUncheckAll(event) {
    this.JsonData.forEach((x) => {
      if (event.checked == true) {
        x.IsSelected = true;
      }
      if (event.checked == false) {
        x.IsSelected = false;
      }
    });
    this.dataSource = new MatTableDataSource(this.JsonData);
  }

  applyFilter(filterValue: string) {
    this.dataSource.filter = filterValue.trim().toLowerCase();
  }
}
